import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const FetchBillSwitchSweepstakesIntroScreen = gql`
  ${AnalyticsFragment}
  query FetchBillSwitchSweepstakesIntroScreen {
    billSwitchSweepstakesIntroScreen {
      __typename
      ... on BillSwitchProductIntroScreen {
        id
        headlineText
        primaryButtonText
        body {
          ... on BillSwitchProductIntroScreenTerms {
            id
            upperText
            bulletsTitle
            bulletPoints
            lowerText
            disclosureText {
              __typename
              id
              html
              linkStyle {
                __typename
                color
                fontStyle
              }
              linkActions {
                __typename
                ... on OpenPdfUrlAction {
                  id
                  url
                  analyticsEvent {
                    __typename
                    ...analytics
                  }
                }
                ... on OpenWebUrlAction {
                  id
                  url
                  analyticsEvent {
                    __typename
                    ...analytics
                  }
                }
              }
            }
          }
        }
      }
      ... on BillSwitchProductIntroScreenError {
        title
        message
        code
      }
    }
  }
`;

export default FetchBillSwitchSweepstakesIntroScreen;
